module.exports = __webpack_public_path__ + "static/media/Frightening Knight.2788b554.jpg";